import { Pipe, PipeTransform } from "@angular/core";
import { IIdentifier } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "identifier" })
export class IdentifierPipe implements PipeTransform {
  /**
   * Pipe to extract an identifier value from an array of identifiers based on a given system.
   * @param identifiers Array of identifiers
   * @param system System to search for
   */
  transform(identifiers: IIdentifier[], system: string): string | undefined {
    return identifiers?.find((id) => id.system === system)?.value;
  }
}
